import { createI18n } from 'vue-i18n'
import el from './locales/el.json'
import en from './locales/en.json'

const messages = {
    en: en,
    el: el,
};

const i18n = createI18n({
    legacy: false,
    locale: 'el', // default
    fallbackLocale: 'el',
    messages,
});

export default i18n;
